import React, { Component } from 'react'
import { UserContext } from '@app/context/user-context'
import { afterSignInRedirect } from '@app/helpers/sessionHelper'

class LandingLayout extends Component {
  static contextType = UserContext

  render() {
    const Component = this.props.component
    const { route, global } = this.props
    const session = this.context

    if (session.isLoggedIn) {
      afterSignInRedirect(session.user, route.history)
      return null
    }

    return (
      <div className="layout layout--landing">
        <Component route={route} global={global} />
      </div>
    )
  }
}

export default LandingLayout
